import React from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
    Paper, Typography, CircularProgress, TablePagination, Box, TextField, InputAdornment
} from '@mui/material';
import RoleListItem from './RoleListItem';

const RolesTable = ({ 
    roles, 
    isLoading, 
    onEdit, 
    onDelete,
    searchTerm,
    setSearchTerm,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    totalRoles
}) => {
    return (
        <Box>
            <Box sx={{ mb: 2.5 }}>
                <TextField
                    size="small"
                    placeholder="Search roles..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        if (onPageChange) onPageChange(null, 0);
                    }}
                    sx={{
                        width: { xs: '100%', sm: 280 },
                        bgcolor: '#ffffff',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            height: 38,
                            fontSize: '0.85rem',
                            backgroundColor: '#ffffff',
                            '& fieldset': {
                                borderColor: '#e2e8f0',
                            },
                            '&:hover fieldset': {
                                borderColor: '#cbd5e1',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#4338ca',
                                borderWidth: '1.5px',
                            },
                        },
                        '& .MuiInputBase-input::placeholder': {
                            color: '#94a3b8',
                            opacity: 1,
                            fontSize: '0.85rem',
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start" sx={{ mr: 1 }}>
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8" />
                                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                </svg>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <TableContainer 
                component={Paper} 
                elevation={0}
                sx={{ 
                    border: '1px solid #e2e8f0',
                    borderRadius: '12px',
                    boxShadow: 'none',
                    overflow: 'hidden',
                    bgcolor: '#ffffff',
                }}
            >
                <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                        <TableRow sx={{ bgcolor: '#f8fafc' }}>
                            <TableCell sx={{ 
                                pl: 3, 
                                py: 1.5, 
                                fontWeight: 600, 
                                fontSize: '0.75rem', 
                                color: '#64748b',
                                borderBottom: '1px solid #e2e8f0',
                                width: '28%',
                            }}>
                                Role & Date
                            </TableCell>
                            <TableCell sx={{ 
                                px: 2, 
                                py: 1.5, 
                                fontWeight: 600, 
                                fontSize: '0.75rem', 
                                color: '#64748b',
                                borderBottom: '1px solid #e2e8f0',
                            }}>
                                Permissions Overview
                            </TableCell>
                            {/* Temporarily hidden: MFA Status */}
                            {false && <TableCell>MFA Status</TableCell>}
                            <TableCell align="right" sx={{ 
                                pr: 3, 
                                py: 1.5, 
                                fontWeight: 600, 
                                fontSize: '0.75rem', 
                                color: '#64748b',
                                borderBottom: '1px solid #e2e8f0',
                                width: '12%',
                            }}>
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {roles.map((role) => (
                            <RoleListItem 
                                key={role.id} 
                                role={role} 
                                onEdit={onEdit} 
                                onDelete={onDelete} 
                            />
                        ))}
                        {roles.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={false ? 4 : 3} align="center" sx={{ py: 6, borderBottom: 'none' }}>
                                    {isLoading ? (
                                        <CircularProgress size={30} sx={{ color: '#4338ca' }} />
                                    ) : (
                                        <Typography sx={{ color: '#64748b', fontSize: '0.875rem' }}>No roles found.</Typography>
                                    )}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={roles.length === 0 ? 0 : totalRoles}
                    page={page}
                    onPageChange={onPageChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={onRowsPerPageChange}
                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                    sx={{
                        borderTop: '1px solid #e2e8f0',
                        color: '#64748b',
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            fontSize: '0.8125rem',
                            color: '#64748b',
                        },
                        '& .MuiTablePagination-select': {
                            fontSize: '0.8125rem',
                            color: '#334155',
                            fontWeight: 600,
                        },
                        '& .MuiTablePagination-actions': {
                            '& .MuiIconButton-root': {
                                color: '#64748b',
                                p: 0.75,
                                '&.Mui-disabled': {
                                    color: '#cbd5e1',
                                },
                            },
                        },
                    }}
                />
            </TableContainer>
        </Box>
    );
};

export default RolesTable;
